import { useSyncExternalStore, useRef } from 'react';
import { storage } from '../websocket/storage';

export function useStorage<T>(key: string): T | null {
  const snapshotRef = useRef<T | null>(null);

  const getSnapshot = (): T | null => {
    const next = storage.get<T>(key);
    if (JSON.stringify(next) !== JSON.stringify(snapshotRef.current)) {
      snapshotRef.current = next;
    }
    return snapshotRef.current;
  };

  const subscribe = (cb: () => void) =>
    storage.subscribe((updatedKey) => {
      if (updatedKey === key || updatedKey === null) cb();
    });

  return useSyncExternalStore(subscribe, getSnapshot, () => null);
}
